function CustomContentView(i18n)
{
    this.i18n = i18n;
}

CustomContentView.prototype.getRoutes = function()
{
    return [{
        name: 'content_index',
        pattern: '/tartalom/{contentId}/:lang:'
    }];
};

CustomContentView.prototype.handleRequest = function(params, render)
{
    var context = {
        _menu: params._route.replace('_index', '')
    };
    switch (params._route) {
        case 'content_index':
            
            render('layout_content.html', context);
            
            $('#ajax-content').load('assets/' + params.contentId.replace('..', '') + '.html');
            
            break;
        default:
            render('error.html', { error_text: 'error.404' });
    }
};
